module.exports = __webpack_public_path__ + "static/media/21ECLAC19.fdfc2073.jpg";